import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=3546e748&scoped=true&lang=pug"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=3546e748&prod&lang=sass&nolang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3546e748",
  null
  
)

export default component.exports